
import {of as observableOf,  Observable } from 'rxjs';

import {map, withLatestFrom, switchMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { OrganisationsApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { CAAction } from '../actions';
import * as actions from '../actions/index';
import * as selectors from '../reducers/index';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';

@Injectable()
export class InviteEffects {
  @Effect()
  sendInvitation = this.actions$
    .ofType(actions.REQUEST_INVITATION_SEND).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
    switchMap(([action, id]) =>
      this.api
        .invite(id, action.payload)
        .map((payload: any) => new actions.ResponseSuccessInvitationSendAction(payload))
        .catch(err => observableOf(new actions.ResponseFailInvitationSendAction(err)))
    ),);

  @Effect()
  bulkInvite = this.actions$
    .ofType(actions.Staff.REQUEST_BULK_IMPORT).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
    switchMap(([action, id]) =>
      this.api
        .importMembers(id, action.payload)
        .map(response => actions.Staff.ResponseSuccessBulkImport(response))
        .catch(err => observableOf(actions.Staff.ResponseFailBulkImport(err)))
    ),);

  @Effect()
  getPending = this.actions$
    .ofType(actions.REQUEST_INVITATIONS_PENDING).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
    switchMap(([action, id]) =>
      this.api
        .listPendingInvitations(id)
        .map(response => new actions.ResponseSuccessPendingInvitations(response))
        .catch(err => observableOf(new actions.ResponseFailPendingInvitations(err)))
    ),);

  @Effect()
  resendInvite = this.actions$
    .ofType(actions.REQUEST_INVITATION_RESEND).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
    switchMap(([action, id]) =>
      this.api
        .resendInvitation(id, action.payload.id)
        .map((payload: any) => new actions.ResponseSuccessInvitationResendAction(payload))
        .catch(err => observableOf(new actions.ResponseFailInvitationResendAction(err)))
    ),);

  @Effect()
  cancelInvite = this.actions$
    .ofType(actions.REQUEST_INVITATION_CANCEL).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))),
    switchMap(([action, id]) =>
      this.dialog
        .open(ConfirmationDialogComponent, {
          data: {
            title: 'Cancel Invitation?',
            body: 'Are you sure you want to cancel this invitation?',
            confirm: 'Cancel invite',
            cancel: 'Keep invite',
            confirmColor: 'warn'
          }
        })
        .afterClosed().pipe(
        map(result => [action, id, result]))
    ),
    switchMap(
      ([action, id, result]) =>
        result
          ? this.api
              .deleteInvitation(id, action.payload.id)
              .map(
                (payload: any) =>
                  new actions.ResponseSuccessInvitationCancelAction({ id: action.payload.id })
              )
              .catch(err => observableOf(new actions.ResponseFailInvitationCancel(err)))
          : observableOf({ type: 'CANCELLED' })
    ),);

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private api: OrganisationsApi,
    private dialog: MatDialog
  ) {}
}
